import { Alert, Box, Heading } from '@ksyos/design-system';
import type { LegendItem } from '@frontend/components/elements/chart/ChartLegend';
import { ChartLegend } from '@frontend/components/elements/chart/ChartLegend';

const legendItems: LegendItem[] = [
    {
        icon: 'circle-lime',
        label: 'Waarde boven grenswaarde',
    },
    {
        icon: 'triangle-red',
        label: 'Alarmwaarde',
    },
    {
        icon: 'dotted-line',
        label: 'Grenswaarde',
    },
];

type ObesiQMonitoringChartHeaderProps = {
    showWarning: boolean;
    title: string;
};

export function ObesiQMonitoringChartHeader(props: ObesiQMonitoringChartHeaderProps) {
    return (
        <Box
            display="flex"
            flexDirection={['column', null, 'row']}
            gap={[2, null, 8]}
            justifyContent="space-between"
            mb={[6]}
        >
            <Box mb={[4, null, 0]}>
                <Box
                    alignItems="center"
                    display="flex"
                    flex-direction="column"
                    flexWrap={['wrap', 'nowrap']}
                    gap={6}
                >
                    <Heading
                        as="h3"
                        fontWeight="medium"
                        size="medium"
                        sx={{
                            flex: [1, 'initial'],
                        }}
                    >
                        {props.title}
                    </Heading>

                    {props.showWarning && (
                        <Alert
                            appearance="warning"
                            hasIcon={true}
                            noMargin={true}
                        >
                            <Alert.Text
                                fontWeight="bold"
                                whiteSpace="nowrap"
                            >
                                Er is een alarm
                            </Alert.Text>
                        </Alert>
                    )}
                </Box>
            </Box>
            <ChartLegend legendItems={legendItems} />
        </Box>
    );
}
